import config from '../../config/appConfig';
import mapboxgl from 'mapbox-gl';
import './mapbox-gl.css';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Omnivirt from '../Omnivert/index';
import AudioPlayer from '../AudioPlayer/index';
import { Grid, Card, CardMedia, CardContent, Typography } from '@material-ui/core';
import { setMapFullWidth } from './actions';
import { styles } from './styles';
import { connect } from 'react-redux';

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: 0,
      openModal: false,
      isClicked: false
    };
  }

  componentDidMount() {
    mapboxgl.accessToken = config.ACCESS_TOKEN;

    if (this.props.story !== null) {
      document.title = 'STYCH - ' + this.props.story.title;
    }

    if (this.props.features === null) {
      return;
    }

    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/dark-v9?optimize=true',
      showZoom: true,
      zoom: 18,
      center: JSON.parse(this.props.features[0].coordinates)
    });

    const features = [
      {
        geometry: {
          type: 'Point',
          coordinates: [-122.4467, 37.7546]
        },
        type: 'Feature',
        properties: {
          id: 0,
          title: 'Twin Peaks',
          caption: 'This is Twin Peaks',
          mediaType: undefined,
          mediaURL: undefined,
          audioURL: undefined
        }
      }
    ];
    if (this.props.features !== null) {
      features.shift();
      this.props.features.map(item =>
        features.push({
          geometry: {
            type: 'Point',
            coordinates: JSON.parse(item.coordinates)
          },
          type: 'Feature',
          properties: {
            id: item.id,
            title: item.title,
            caption: item.caption,
            mediaType: item.mediaType,
            mediaURL: item.mediaURL,
            audioURL: item.audioURL
          }
        })
      );
    }

    map.on('load', () => {
      map.loadImage(
        'https://cdn1.iconfinder.com/data/icons/social-messaging-ui-color/254000/66-32.png',
        (error, image) => {
          if (error) throw error;
          map.addImage('custom-marker', image);
          map.addLayer({
            id: 'markers',
            type: 'symbol',
            source: {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features
              }
            },
            layout: {
              'icon-image': 'custom-marker'
            }
          });
        }
      );

      const popup = new mapboxgl.Popup({
        offset: 20,
        closeButton: false,
        closeOnClick: false
      });

      const onMouseEnter = function(e) {
        map.getCanvas().style.cursor = 'pointer';

        const coordinates = e.features[0].geometry.coordinates.slice();
        const title = e.features[0].properties.title;

        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        popup
          .setLngLat(coordinates)
          .setHTML(`<h3>${title}</h3>`)
          .addTo(map);
      };

      map.on('mouseenter', 'markers', onMouseEnter);

      const onMouseLeave = function() {
        map.getCanvas().style.cursor = '';
        popup.remove();
      };

      map.on('mouseleave', 'markers', onMouseLeave);

      map.on('click', 'markers', e => {
        const arf = e.features;
        const currentId = 'read-' + Date.now();

        map.loadImage(
          'https://cdn1.iconfinder.com/data/icons/social-messaging-ui-color/254000/67-32.png',
          (error, image) => {
            if (error) throw error;
            map.addImage('clicked-marker', image);
            map.addLayer({
              id: currentId,
              type: 'symbol',
              source: {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features: [arf[0]]
                }
              },
              layout: {
                'icon-image': 'clicked-marker'
              }
            });
          }
        );
        map.on('mouseleave', currentId, onMouseLeave);
        map.on('mouseenter', currentId, onMouseEnter);
        map.on('click', currentId, e => {
          this.setState({
            openModal: true,
            isClicked: true,
            title: e.features[0].properties.title,
            caption: e.features[0].properties.caption,
            mediaType: e.features[0].properties.mediaType,
            mediaURL: e.features[0].properties.mediaURL,
            audioURL: e.features[0].properties.audioURL
          });
        });

        this.setState({
          openModal: true,
          isClicked: true,
          title: e.features[0].properties.title,
          caption: e.features[0].properties.caption,
          mediaType: e.features[0].properties.mediaType,
          mediaURL: e.features[0].properties.mediaURL,
          audioURL: e.features[0].properties.audioURL
        });
        this.props.setMapFullWidth(true);
        setTimeout(() => {
          map.resize();
        }, 1000);
      });
    });
    const bounds = new mapboxgl.LngLatBounds();
    features && features.map(feature => bounds.extend(feature.geometry.coordinates));
    map.fitBounds(bounds, { padding: 100 });
  }

  handleClose = () => {
    this.setState({ openModal: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div ref={(x => (this.mapContainer = x), y => (this.mapContainer = y))} className={classes.map} />

        <Modal open={this.state.openModal} onClose={this.handleClose}>
          <Card className={classes.paper}>
            <IconButton aria-label='Close' onClick={this.handleClose} className={classes.closeButton}>
              <CloseIcon />
            </IconButton>

            <CardContent className={classes.POI}>
              <Typography variant='h5' component='h2' className={classes.title}>
                {this.state.title}
              </Typography>
              <Grid container className={classes.modalContent}>
                <CardMedia p={0} className={classes.media}>
                  {this.state.mediaType === 'video' ? (
                    <Omnivirt mediaURL={this.state.mediaURL} />
                  ) : (
                    <img src={this.state.mediaURL} alt='storyPhoto' />
                  )}
                  <Grid container className={classes.audioPlayer}>
                    <Grid item md={7}>
                      {this.state.audioURL !== undefined ? <AudioPlayer audioURL={this.state.audioURL} /> : null}
                    </Grid>
                    <Grid item md={5}>
                      <Typography className={classes.caption} variant='body2' component='p'>
                        {this.state.caption}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardMedia>
              </Grid>
            </CardContent>
          </Card>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    features: state.storyDetailsReducer.pointsOfInterest,
    story: state.storyDetailsReducer.story
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMapFullWidth: isClicked => {
      dispatch(setMapFullWidth(isClicked));
    }
  };
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);

export default withStyles(styles)(withConnect);
